const PERMISSION_KEY = 'user_permissions';
const MODULE_KEY = 'user_modules';

export const permissionsService = {

  setPermissions(permissions) {
    localStorage.setItem(PERMISSION_KEY, JSON.stringify(permissions));
  },

  getPermissions() {
    const permissions = localStorage.getItem(PERMISSION_KEY);
    return permissions ? JSON.parse(permissions) : {};
  },

  getPermissionsByModule(moduleName) {
    const permissions = localStorage.getItem(PERMISSION_KEY);
    const permissionsData = permissions ? JSON.parse(permissions) : [];
    const moduleData = permissionsData.find(permission => permission.name === moduleName);
    return moduleData?.permissions || [];
  },

  clearPermissions() {
    localStorage.removeItem(PERMISSION_KEY);
    localStorage.removeItem(MODULE_KEY);
  },

  setPermissionModules(modules) {
    localStorage.setItem(MODULE_KEY, JSON.stringify(modules));
  },

  getPermissionModules() {
    const modules = localStorage.getItem(MODULE_KEY);
    return modules ? JSON.parse(modules) : {};
  }
  
};